<template>
  <div class="user-info-modify-page">
      <div slot="header" class="card-header">
        <h2>用户信息修改</h2>
      </div>
      <div class="page-content">
        <!-- 修改密码表单 -->
        <div class="password-form-container">
          <div class="password-form-card">
            <h2 class="form-title">修改密码</h2>
            <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" class="password-form" border  height="500">
              <el-form-item label="当前登录密码" prop="currentPassword" class="form-item">
                <el-input 
                  v-model="passwordForm.currentPassword" 
                  type="password" 
                  placeholder="请输入当前密码"
                  show-password
                  class="password-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="新密码" prop="newPassword" class="form-item">
                <el-input 
                  v-model="passwordForm.newPassword" 
                  type="password" 
                  placeholder="请输入新密码"
                  show-password
                  class="password-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="确认密码" prop="confirmPassword" class="form-item">
                <el-input 
                  v-model="passwordForm.confirmPassword" 
                  type="password" 
                  placeholder="请再次输入新密码"
                  show-password
                  class="password-input">
                </el-input>
              </el-form-item>
              
              <div class="form-actions">
                <el-button type="primary" class="confirm-btn" @click="handleSubmit">确定</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoModify',
  data() {
    return {
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    handleSubmit() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.$message.success('密码修改成功')
          // 这里可以添加提交逻辑
        } else {
          this.$message.error('请检查输入信息')
        }
      })
    }
  }
}
</script>

<style scoped>
.user-info-modify-page {
  padding: 0;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-header {
  display: none;
}

.page-content {
  padding: 0;
}

/* 密码表单容器 */
.password-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  overflow: hidden;
}

.password-form-card {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.form-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.password-form {
  height: 500px;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

.confirm-btn {
  width: 100%;
  height: 40px;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.confirm-btn:active {
  background-color: #3a8ee6;
  border-color: #3a8ee6;
}

</style>
